import React from 'react';
import { Container } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-3">
      <Container>
        <small>Copyright © 2025. All Rights Reserved - John Michael Catapia</small>
      </Container>
    </footer>
  );
};

export default Footer;